module.exports = require('./lib/promise-composer-build');